import { request } from './Auth';
export async function prepareImage(file) {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return file;
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, 2000 / bitmap.width);
  const canvas = document.createElement('canvas');
  canvas.width = Math.round(bitmap.width * scale);
  canvas.height = Math.round(bitmap.height * scale);
  if (canvas.height > 16000) { bitmap.close(); throw new Error('This image is too tall. Split it into shorter pages before uploading.'); }
  canvas.getContext('2d').drawImage(bitmap, 0, 0, canvas.width, canvas.height);
  bitmap.close();
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/webp', .9));
  if (!blob) throw new Error('This image could not be prepared for upload.');
  return blob.size < file.size ? blob : file;
}
export async function upload(file) {
  if (!['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'video/mp4', 'video/webm'].includes(file.type)) throw new Error('Use JPG, PNG, WebP, GIF, MP4, or WebM.');
  if (file.size > (file.type.startsWith('video/') ? 200 : 20) * 1024 * 1024) throw new Error('Images must be under 20 MB; videos under 200 MB.');
  const prepared = await prepareImage(file);
  const data = await request('/api/r2-sign-put', { method: 'POST', body: JSON.stringify({ contentType: prepared.type, size: prepared.size }) });
  const result = await fetch(data.uploadUrl, { method: 'PUT', headers: { 'Content-Type': prepared.type, 'Cache-Control': 'public, max-age=31536000, immutable' }, body: prepared });
  if (!result.ok) throw new Error('Upload failed. Check the storage connection and try again.');
  return data.publicUrl;
}
